import React from 'react';
import '../css/about.css';
import CountUp from './CountUp';

const About = () => {
  return (
    <section className="aboutMe" id="about">
      <h2 className="section-heading">About Me</h2>
      <div className="aboutContent">
        <div className="aboutText">
          <p className="para">
            Hi there! I'm Syed Ghyas Ali, a passionate Frontend Developer specializing in creating
            exceptional digital experiences. With expertise in HTML5, CSS3, JavaScript, and modern
            frameworks like React, I transform ideas into beautiful, functional websites.
          </p>
          <p className="para">
            I believe in writing clean, efficient code and staying up-to-date with the latest
            technologies. When I'm not coding, I'm probably working on a side project, exploring
            new technologies, or contributing to open-source projects.
          </p>
          <div className="stats">
            <div className="stat">
              <h3><CountUp to={20} duration={2} />+</h3>
              <p>Projects Completed</p>
            </div>
            <div className="stat">
              <h3><CountUp to={1} duration={2} />+</h3>
              <p>Years Experience</p>
            </div>
            <div className="stat">
              <h3><CountUp to={100} duration={2} />%</h3>
              <p>Dedication</p>
            </div>
          </div>
        </div>
        <div className="aboutImage">
          <img src="/images/my-image.png" alt="Syed Ghyas Ali" />
        </div>
      </div>
    </section>
  );
};

export default About;
